module.exports = __webpack_public_path__ + "static/2021_map_mobile-004837fa7e8f67b6e022ec2e18d0a9b5.jpg";